import React from "react";
import iconWinOne from "../../../../assets/images/event-2024/win-1.png";
import iconWinTwo from "../../../../assets/images/event-2024/win-2.png";
import iconWinThree from "../../../../assets/images/event-2024/win-3.png";
import iconGiftOne from "../../../../assets/images/event-2024/gift-1.png";
import iconGiftTwo from "../../../../assets/images/event-2024/gift-2.png";
import iconGiftThree from "../../../../assets/images/event-2024/gift-3.png";
import moneySpec from "../../../../assets/images/event-2024/money-spec.png";
import { useQuery } from "react-query";
import { getRankNewYear2024 } from "dataLayer/user";
import { ID_RANK_TABLE_EVENT_2024 } from "@config/constants/helper";
import { getHistoryEventNoel } from "dataLayer/product";
import iconPhao from "../../../../assets/images/event-2024/icon-phao.png"

const page = 1;
const totalPage = 3;
export default function BoxWinner() {
  const { data: dataRank = {}, isLoading } = useQuery(
    getRankNewYear2024(page, totalPage, ID_RANK_TABLE_EVENT_2024.rank)
  );
  const { data: historyEventNoel = {}, refetch } = useQuery(
    getHistoryEventNoel()
  );
  const { resultHistory = [], resultSpeHis = [] } = historyEventNoel;

  const { ranks = {} } = dataRank;
  const { data = [] } = ranks;

  return (
    <div className="box-winner">
      <div className="box-winner-top">
        <div className="box-winner-top-item">
          <div>
            <img src={iconWinOne} alt="" className="icon-rank" />
          </div>
          <div>
            <img src={iconGiftOne} alt="" className="icon-gift" />
          </div>
          <div>
            <span>{data[0]?.isdn}</span>
            <span style={{ display: "flex", alignItems: "center" }}>
              <img src={iconPhao} className="icon-phao-container" alt="" />
              &nbsp;{data[0]?.firework}
            </span>
          </div>
        </div>
        <div className="box-winner-top-item">
          <div>
            <img src={iconWinTwo} alt="" className="icon-rank" />
          </div>
          <div>
            <img src={iconGiftTwo} alt="" className="icon-gift" />
          </div>
          <div>
            <span>{data[1]?.isdn}</span>
            <span style={{ display: "flex", alignItems: "center" }}>
              <img src={iconPhao} className="icon-phao-container" alt="" />
              &nbsp;{data[1]?.firework}
            </span>
          </div>
        </div>
        <div className="box-winner-top-item">
          <div>
            <img src={iconWinThree} alt="" className="icon-rank" />
          </div>
          <div>
            <img src={iconGiftThree} alt="" className="icon-gift" />
          </div>
          <div>
            <span>{data[2]?.isdn}</span>
            <span style={{ display: "flex", alignItems: "center" }}>
              <img src={iconPhao} className="icon-phao-container" alt="" />
              &nbsp;{data[2]?.firework}
            </span>
          </div>
        </div>
      </div>
      <div className="box-winner-special">
        <div className="title-special">
          <img src={moneySpec} alt="" />
        </div>
        <ul className="list-winner-special">
          {resultSpeHis.map((item) => {
            return <li key={item.id}>{item.isdn}</li>;
          })}
        </ul>
      </div>
    </div>
  );
}
